import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import EditRoundedIcon from '@mui/icons-material/EditRounded'
import RemoveRedEyeRoundedIcon from '@mui/icons-material/RemoveRedEyeRounded'
import {
  IconButton,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material'
import TableCell from '@mui/material/TableCell'
import React from 'react'
import { FamiliarReferenceType } from 'types/familiar-reference.type'
import { formatAddressField } from 'utils/text.util'
import { StyledTableCell } from './styles'

type TableDataProps = {
  data: FamiliarReferenceType[]
  onVisualize: (data: FamiliarReferenceType) => void
  onEdit: (data: FamiliarReferenceType) => void
  onDelete: (data: FamiliarReferenceType) => void
}

const TableData: React.FC<TableDataProps> = ({ data, onVisualize, onEdit, onDelete }) => {
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <StyledTableCell>Vínculo</StyledTableCell>
            <StyledTableCell>Nome</StyledTableCell>
            <StyledTableCell sx={{ minWidth: 140 }}>CPF</StyledTableCell>
            <StyledTableCell>Endereço</StyledTableCell>
            <StyledTableCell align='center' sx={{ minWidth: 140 }}>
              Ações
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item, i) => (
            <TableRow hover key={i}>
              <TableCell>{item.tipoReferencia.descricao}</TableCell>
              <TableCell>{item.pessoaReferencia.nome}</TableCell>
              <TableCell>{item.pessoaReferencia.cpf}</TableCell>
              <TableCell>{formatAddressField(item.endereco)}</TableCell>
              <TableCell align='center'>
                <Tooltip title='Visualizar'>
                  <IconButton color='info' aria-label='visualize' onClick={() => onVisualize(item)}>
                    <RemoveRedEyeRoundedIcon fontSize='small' />
                  </IconButton>
                </Tooltip>
                <Tooltip title='Editar'>
                  <IconButton color='info' aria-label='Editar' onClick={() => onEdit(item)}>
                    <EditRoundedIcon fontSize='small' />
                  </IconButton>
                </Tooltip>
                <Tooltip title='Excluir'>
                  <IconButton color='info' aria-label='Excluir' onClick={() => onDelete(item)}>
                    <DeleteOutlinedIcon fontSize='small' />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default TableData
